import {
  Rocket, Target, Flag, Trophy, Compass, Lightbulb, Star,
  Server, Database, Code, Cpu, Shield, Lock, Key,
  Package, Layers, Grid, Layout, Box, Boxes,
  Users, User, Building, Globe, Briefcase,
  Calendar, Clock, Timer, Hourglass,
  CheckCircle, AlertTriangle, Pause, Play, Circle,
  TrendingUp, BarChart, Sparkles, Zap,
  UserCheck
} from 'lucide-react';

export const ICON_MAP = {
  'rocket': Rocket, 'target': Target, 'flag': Flag, 'trophy': Trophy,
  'compass': Compass, 'lightbulb': Lightbulb, 'star': Star,
  'server': Server, 'database': Database, 'code': Code, 'cpu': Cpu,
  'shield': Shield, 'lock': Lock, 'key': Key,
  'package': Package, 'layers': Layers, 'grid': Grid, 'layout': Layout,
  'box': Box, 'cube': Boxes,
  'users': Users, 'user': User, 'building': Building, 'globe': Globe,
  'briefcase': Briefcase,
  'calendar': Calendar, 'clock': Clock, 'timer': Timer, 'hourglass': Hourglass,
  'check-circle': CheckCircle, 'alert-triangle': AlertTriangle,
  'pause': Pause, 'play': Play, 'circle': Circle,
  'trending-up': TrendingUp, 'bar-chart': BarChart, 'sparkles': Sparkles,
  'zap': Zap,
};

export const ICON_OPTIONS = Object.keys(ICON_MAP);

export const BADGE_COLORS = {
  blue: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400',
  green: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400',
  yellow: 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400',
  red: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400',
  purple: 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400',
  gray: 'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-300',
};

export const ACCESS_OPTIONS = [
  { value: 'public', label: 'Public', icon: Globe, description: 'Anyone with the link can view' },
  { value: 'all_users', label: 'All Organization Users', icon: Users, description: 'Only logged-in org members can view' },
  { value: 'selected_users', label: 'Selected Users', icon: UserCheck, description: 'Only specific users can view' },
];

export const DEFAULT_BRANDING = {
  logo_position: 'left',
  primary_color: '#8b5cf6',
  secondary_color: '#c4b5fd',
  text_color: '',
  date_color: '',
  background_color: '',
  display_style: 'icons',
  line_config: [
    { level: 1, enabled: true, style: 'dashed' },
    { level: 2, enabled: true, style: 'dashed' },
    { level: 3, enabled: true, style: 'dashed' },
  ],
};

export const BULLET_OPTIONS = [
  { value: 'dot', label: 'Standard Dot', preview: '●' },
  { value: 'circle', label: 'Open Circle', preview: '○' },
  { value: 'square', label: 'Square', preview: '■' },
  { value: 'diamond', label: 'Diamond', preview: '◆' },
  { value: 'dash', label: 'Dash', preview: '—' },
  { value: 'arrow-right', label: 'Arrow Right', preview: '▶' },
  { value: 'arrow-up', label: 'Arrow Up', preview: '▲' },
  { value: 'arrow-down', label: 'Arrow Down', preview: '▼' },
  { value: 'arrow-left', label: 'Arrow Left', preview: '◀' },
  { value: 'check', label: 'Checkmark', preview: '✓' },
];

export const SR_DEFAULTS = {
  primary_color: '#8b5cf6',
  secondary_color: '#c4b5fd',
  text_color: '#1a1a1a',
  date_color: '#6b7280',
  background_color: '#ffffff',
};
